<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style>
html, body {
  font-size: 12px;
  background: #1e1e1e !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #999;
  padding: 60px 16px 16px 16px;
  max-width: 666px;
  margin: auto;
}
</style>
